module.exports = __webpack_public_path__ + "img/career-a3.94d21779.jpg";